<template>
  <div>
    <a href="#" data-testid="action-apply-template" v-bind="$attrs" v-on="$listeners" @click="onClick()">
      <img v-if="! proUser"
           src="@img/pro-ribbon.png" class="img-pro-ribbon" :data-testid="'img-pro-ribbon-' + id">
      <span data-toggle="tooltip" data-placement="top" :title="title" class="icon">
        <img :src="icon" :alt="title">
      </span>
      <p class="owner-action-label"><slot></slot></p>
    </a>
  </div>
</template>

<script>
export default  {
  props: ["title", "id", "icon"],
  computed: {
    proUser: function() {
      return (this.$store.state.currentOrganization.attributes.is_paying != false);
    }
  },
  methods: {
    onClick: function(event) {
      if (this.proUser) {
        this.$emit("pro-click", event);
      } else {
        this.$emit("free-click", event);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/packs/application.scss';

span.icon {
  display: inline-block;
  height: 100%;
  vertical-align: top;
}

img {
  height: 1rem;
  vertical-align: top;
}
</style>